import $ from 'jquery';
import Backbone from 'backbone';
import _ from 'underscore';
import template from 'hbars!templates/tutorialPopUp';
import Global from 'models/Global';
import jqueryCookie from 'jquery-cookie';
import Config from 'config';

var TutorialView = Backbone.View.extend({
    events: {
        'click .tutorial-popup-tab': 'tabClicked',
        'click .tutorial-popup-next-button': 'nextClicked',
        'click .tutorial-popup-skip-button': 'remove'
    },

    initialize: function() {
        localStorage.setItem( 'x-bz-tutorial', true );
    },

    tabClicked: function(e, openTab) {
        var NUMBER_OF_TABS = 5;
        var value = e ? $(e.target).parent().attr('value') : openTab + 1;
        if (!value) {
            return;
        } else if (value == NUMBER_OF_TABS) {
            this.remove();
        } else if (value == NUMBER_OF_TABS - 1) {
            this.$('.tutorial-popup-next-button').text('Done');
        } else {
            this.$('.tutorial-popup-next-button').text('Next');
        }
        _.each(this.$('.tutorial-popup-tab'), function(tab, index){
            if ($(tab).attr('value') == value) {
                this.$(tab).toggleClass('tutorial-popup-tab-open', true);
                this.$(tab).find('img').toggleClass('tutorial-popup-image-open', false);
            } else {
                this.$(tab).find('img').toggleClass('tutorial-popup-image-open', true);
                this.$(tab).toggleClass('tutorial-popup-tab-open', false);
            }
        }, this);
    },

    nextClicked: function() {
        var value = parseInt(this.$('.tutorial-popup-tab-open').attr('value'), 10);
        this.tabClicked(undefined, value);
    },

    render: function() {
        var thisView = this;
        $('body').append('<div class=\'tutorial-popup-overlay hidden-xs\'></div> ');
        this.$el.html(template({eventName: Global.get('event').get('name')}));
        $('.tutorial-popup').html(this.$el);
        setTimeout(function(){
            $(thisView.$el).find('.tutorial-popup-container').toggleClass('tutorial-popup-opacity');
        }, 300);
        return this;
    },

    sentToturialSeenToServer: function() {
        Backbone.ajax({
            url: Config.baseV2Url + '/userProfile/tutorial',
            method: 'POST'
        });
    },

    remove: function() {
        $('.tutorial-popup-overlay').remove();
        this.sentToturialSeenToServer();
        this.$el.remove();
        this.stopListening();
        return this;
    }

});
export default TutorialView;

